import fetch from '@/service/fetch';

export function getList(params) {
  return fetch('/api/portal/art/encyclopedias/page', {
    data: params
  })
}